import { APP_INITIALIZER, NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { HttpErrorInterceptor } from "./http.interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
  POSITION,
  PB_DIRECTION,
} from "ngx-ui-loader";
import { WindowRef } from "./WindowRef";
import { ToastrModule } from "ngx-toastr";
import { Router, RouterModule, Routes } from "@angular/router";
import { ScriptService } from "./service/script.service";
import { PosthogService } from './service/posthog.service';


const routes: Routes = [
  { path: '', redirectTo: '/newlogin',  pathMatch: 'full'},
  { path: '', loadChildren: () => import('./app-routing.module').then(m => m.AppRoutingModule)},
];

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "#d3d3d3",
  overlayColor: "rgba(0,0,0,0)",
  bgsPosition: POSITION.centerCenter,
  fgsPosition: POSITION.centerCenter,
  bgsSize: 40,
  hasProgressBar: true,
  pbColor: "#06064d",
  delay: 100,
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 4, // progress bar thicknesss
};
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    RouterModule.forRoot(routes, {}),
    ToastrModule.forRoot({
      closeButton: false,
      preventDuplicates: true,
      maxOpened: 1,
    }),
  ],
  providers: [
    WindowRef,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    ScriptService,
    PosthogService,
    provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
